import {createSlice} from "@reduxjs/toolkit"
import { CART_STORAGE_KEY } from "../utils/config"

function loadInitialState(){
    try {
        const saved = localStorage.getItem(CART_STORAGE_KEY);
        if(saved){
            const parsed = JSON.parse(saved);
            if(parsed && Array.isArray(parsed.items) && typeof parsed.count === "number"){
                return parsed;
            }
        }
    } catch (e) {
        // localStorage unavailable or holding corrupted data - fall back to empty cart
    }
    return { items: [], count: 0 };
}

const cart = createSlice({
    name: 'cartslice',
    initialState: loadInitialState(),
    reducers:{
       addItems: (state,action)=>{
            state.items.push({...action.payload, quantity:1});
            state.count++;
       },
       IncrementItems: (state,action)=>{
         const element =  state.items.find(item=> item.id===action.payload.id); 
         element.quantity+=1;
         state.count++;
       },
       DecrementItems: (state,action)=>{
        const element =  state.items.find(item=> item.id===action.payload.id);
        if(element.quantity>1){
            element.quantity-=1;
        }
        else{
            state.items = state.items.filter(item=> item.id!=action.payload.id);
        }
        state.count--;
       }
    }
})

export const {addItems, IncrementItems, DecrementItems} = cart.actions;
export default cart.reducer;



